import { ACTION_TYPE } from './action';

const memoList = (state = {}, action) => {
  switch (action.type) {
    case ACTION_TYPE.CALL_API_SELECT_MEMO_STORES_SUCCESS:
      return {
        ...state,
        stores: action.selects,
      };
    case ACTION_TYPE.CALL_API_MEMO_SEARCH_SUCCESS:
      return {
        ...state,
        datas: action.datas,
      };
    case ACTION_TYPE.RESET_MEMO_FLG:
      return {
        ...state,
        isDeleteSuccess: false,
      };
    case ACTION_TYPE.CALL_API_DELETE_MEMO_SUCCESS:
      return {
        ...state,
        isDeleteSuccess: true,
      };
    default:
      return state;
  }
};

export default memoList;
